(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aa-newsletter-advanced"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAaNewsletterAdvanced(root) {
    if (!root || root.dataset.naInit === 'true') return;
    root.dataset.naInit = 'true';

    var form = root.querySelector('[data-aa-newsletter-advanced-form-wrapper] form');
    if (!form) return;

    var field = root.querySelector('[data-aa-newsletter-advanced-field]');
    var input = root.querySelector('[data-aa-newsletter-advanced-input]');
    var submitBtn = root.querySelector('[data-aa-newsletter-advanced-submit]');
    var inlineError = root.querySelector('[data-aa-newsletter-advanced-inline-error]');
    var consent = root.querySelector('[data-aa-newsletter-advanced-consent]');
    var wrapper = root.querySelector('[data-aa-newsletter-advanced-form-wrapper]');

    var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function showInlineError(msg) {
      if (!inlineError) return;
      inlineError.textContent = msg;
      inlineError.hidden = false;
      if (field) field.classList.add('is-invalid');
    }
    function clearInlineError() {
      if (!inlineError) return;
      inlineError.hidden = true;
      inlineError.textContent = '';
      if (field) field.classList.remove('is-invalid');
    }
    function setLoading(isLoading) {
      if (!submitBtn) return;
      submitBtn.disabled = isLoading;
      submitBtn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    if (input) {
      input.addEventListener('input', clearInlineError);
    }

    function bindCopyButtons(scope) {
      var btn = scope.querySelector('[data-aa-newsletter-advanced-copy]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code') || '';
        var done = function () {
          btn.dataset.copied = 'true';
          var original = btn.textContent;
          btn.textContent = 'Copied!';
          setTimeout(function () {
            btn.textContent = original;
            btn.dataset.copied = 'false';
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(function () { fallbackCopy(code, done); });
        } else {
          fallbackCopy(code, done);
        }
      });
    }
    function fallbackCopy(text, done) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      done();
    }
    bindCopyButtons(root);

    form.addEventListener('submit', function (e) {
      clearInlineError();

      var emailValue = input ? input.value.trim() : '';
      if (!emailValue || !emailRe.test(emailValue)) {
        e.preventDefault();
        showInlineError('Please enter a valid email address.');
        if (input) input.focus();
        return;
      }
      if (consent && !consent.checked) {
        e.preventDefault();
        showInlineError('Please agree to continue.');
        return;
      }

      // Progressive enhancement: try a no-reload submit. If anything goes
      // wrong, fall back to a normal form post (full page reload).
      if (typeof fetch !== 'function' || typeof DOMParser !== 'function') return;

      e.preventDefault();
      setLoading(true);

      var formData = new FormData(form);
      fetch(form.action, { method: 'POST', body: formData, credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshRoot = doc.getElementById(root.id);
          if (!freshRoot) {
            form.submit();
            return;
          }
          var freshWrapper = freshRoot.querySelector('[data-aa-newsletter-advanced-form-wrapper]');
          if (freshWrapper && wrapper) {
            wrapper.innerHTML = freshWrapper.innerHTML;
            var successEl = wrapper.querySelector('[data-aa-newsletter-advanced-success]');
            var errorEl = wrapper.querySelector('[data-aa-newsletter-advanced-error]');
            var focusTarget = successEl || errorEl;
            if (focusTarget) focusTarget.focus({ preventScroll: false });
            bindCopyButtons(wrapper);
          } else {
            form.submit();
          }
        })
        .catch(function () { form.submit(); })
        .finally(function () { setLoading(false); });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-aa-newsletter-advanced-section]').forEach(initAaNewsletterAdvanced);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-reviews-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function store(key, value) {
      try {
        if (value === undefined) return localStorage.getItem(key);
        if (value === null) localStorage.removeItem(key);
        else localStorage.setItem(key, value);
      } catch (e) {
        return null;
      }
    }

    function initReviews(root) {
      if (!root || root.dataset.aaRvInit === 'true') return;
      root.dataset.aaRvInit = 'true';

      var list = root.querySelector('[data-aa-rv-list]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-aa-rv-item]'));
      var moreBtn = root.querySelector('[data-aa-rv-more]');
      var sortSelect = root.querySelector('[data-aa-rv-sort]');
      var perPage = parseInt(root.dataset.perPage, 10) || 5;
      var shown = perPage;

      function paginate() {
        var ordered = list.querySelectorAll('[data-aa-rv-item]');
        ordered.forEach(function (item, i) {
          item.hidden = i >= shown;
        });
        if (moreBtn) moreBtn.hidden = shown >= ordered.length;
      }

      function num(item, key) {
        return parseFloat(item.dataset[key]) || 0;
      }

      function sortBy(mode) {
        var sorted = items.slice().sort(function (a, b) {
          if (mode === 'highest') return num(b, 'rating') - num(a, 'rating') || num(a, 'index') - num(b, 'index');
          if (mode === 'lowest') return num(a, 'rating') - num(b, 'rating') || num(a, 'index') - num(b, 'index');
          if (mode === 'helpful') return num(b, 'helpful') - num(a, 'helpful') || num(a, 'index') - num(b, 'index');
          if (mode === 'media') {
            var am = a.dataset.media === 'true' ? 0 : 1;
            var bm = b.dataset.media === 'true' ? 0 : 1;
            return am - bm || num(a, 'index') - num(b, 'index');
          }
          return num(a, 'index') - num(b, 'index');
        });
        sorted.forEach(function (item) {
          list.appendChild(item);
        });
        shown = perPage;
        paginate();
      }

      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          sortBy(sortSelect.value);
        });
      }

      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          var firstHidden = list.querySelector('[data-aa-rv-item][hidden]');
          shown += perPage;
          paginate();
          if (firstHidden) firstHidden.setAttribute('tabindex', '-1'), firstHidden.focus({ preventScroll: true });
        });
      }

      paginate();

      // Helpful votes: one vote per review per browser, can be changed or undone.
      root.querySelectorAll('[data-aa-rv-helpful]').forEach(function (group) {
        var key = 'aa-rv-vote-' + group.dataset.key;
        var buttons = group.querySelectorAll('[data-vote]');

        function render(vote) {
          buttons.forEach(function (btn) {
            var active = btn.dataset.vote === vote;
            var base = parseInt(btn.dataset.base, 10) || 0;
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
            btn.querySelector('[data-count]').textContent = base + (active ? 1 : 0);
          });
        }

        render(store(key));

        buttons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var current = store(key);
            var next = current === btn.dataset.vote ? null : btn.dataset.vote;
            store(key, next);
            render(next);
          });
        });
      });

      // Photo popup.
      var dialog = root.querySelector('[data-aa-rv-dialog]');
      if (dialog && typeof dialog.showModal === 'function') {
        var dialogImg = dialog.querySelector('[data-aa-rv-dialog-img]');
        root.querySelectorAll('[data-aa-rv-photo]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var thumb = btn.querySelector('img');
            dialogImg.src = btn.dataset.aaRvPhoto;
            dialogImg.alt = thumb ? thumb.alt : '';
            dialog.showModal();
          });
        });
        dialog.querySelector('[data-aa-rv-close]').addEventListener('click', function () {
          dialog.close();
        });
        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', function () {
          dialogImg.removeAttribute('src');
        });
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-aa-rv]').forEach(initReviews);
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-style-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Convert the "speed" setting (px per second) into an animation
    // duration based on the real width of one slide group, so the strip
    // moves at the same pace whatever the number of slides or screen size.
    function setDuration(root) {
      var track = root.querySelector('[data-aa-sm-track]');
      var group = track && track.firstElementChild;
      if (!group) return;
      var speed = parseFloat(root.dataset.speed) || 40;
      if (window.innerWidth < 750) speed = speed * 0.75;
      var seconds = group.getBoundingClientRect().width / speed;
      if (seconds > 0) root.style.setProperty('--aa-sm-duration', seconds.toFixed(2) + 's');
    }

    function initMarquee(root) {
      if (!root || root.dataset.aaSmInit === 'true') return;
      root.dataset.aaSmInit = 'true';
      setDuration(root);

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          setDuration(root);
        }, 150);
      });

      // Images load lazily, so re-measure once they arrive.
      root.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', function () { setDuration(root); }, { once: true });
      });

      // Draw the heading underline the first time the section is seen.
      if (root.classList.contains('aa-sm--animate-line')) {
        if ('IntersectionObserver' in window) {
          var lineObserver = new IntersectionObserver(
            function (entries) {
              if (entries[0].isIntersecting) {
                root.classList.add('is-in-view');
                lineObserver.disconnect();
              }
            },
            { threshold: 0.3 }
          );
          lineObserver.observe(root.querySelector('.aa-sm__heading') || root);
        } else {
          root.classList.add('is-in-view');
        }
      }

      // Pause offscreen to save battery/CPU.
      var track = root.querySelector('[data-aa-sm-track]');
      if (track && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          track.style.animationPlayState = entries[0].isIntersecting ? '' : 'paused';
        }).observe(root);
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-aa-sm]').forEach(initMarquee);
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-winter-announcement-bar"] && !Shopify.designMode) return;
  try {
    
function aaWinterBarInit() {
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  document.querySelectorAll('[data-aa-wbar]').forEach(function (bar) {
    if (bar.dataset.aaInit) return;
    bar.dataset.aaInit = 'true';

    // Close button: remembered for the browser session (ignored in the theme editor so it stays editable).
    var key = bar.dataset.dismissKey;
    if (key && !designMode) {
      try {
        if (sessionStorage.getItem(key) === '1') {
          bar.hidden = true;
          return;
        }
      } catch (e) {}
    }
    var closeBtn = bar.querySelector('[data-aa-wbar-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        if (key && !designMode) {
          try { sessionStorage.setItem(key, '1'); } catch (e) {}
        }
      });
    }

    // Countdown: every copy (static + ticker clone) is updated together.
    var timers = bar.querySelectorAll('[data-aa-wbar-countdown]');
    var end = new Date(bar.dataset.end).getTime();
    if (isNaN(end)) return;
    var hideBar = bar.dataset.hideOnExpire === 'true';
    var interval;

    function pad(n) {
      return String(n).padStart(2, '0');
    }
    function set(sel, value) {
      bar.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
    }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        if (hideBar && !designMode) bar.hidden = true;
        bar.querySelectorAll('[data-aa-wbar-countdown], [data-aa-wbar-countdown-sep]').forEach(function (t) { t.hidden = true; });
        if (interval) clearInterval(interval);
        return;
      }
      if (!timers.length) return;
      set('[data-d]', pad(Math.floor(diff / 86400000)));
      set('[data-h]', pad(Math.floor((diff % 86400000) / 3600000)));
      set('[data-m]', pad(Math.floor((diff % 3600000) / 60000)));
      set('[data-s]', pad(Math.floor((diff % 60000) / 1000)));
    }

    tick();
    interval = setInterval(tick, 1000);
  });
}

aaWinterBarInit();
document.addEventListener('shopify:section:load', aaWinterBarInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
